var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactCenterHelpDesk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.5,
    height: 27.876,
    viewBox: "0 0 24.5 27.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help-desk",
    transform: "translate(-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3395",
    "data-name": "Path 3395",
    d: "M48.695,355H47.324a4.082,4.082,0,0,1-8.147,0H37.806A6.813,6.813,0,0,0,31,361.806v.926a.817.817,0,0,0,.817.817H54.684a.817.817,0,0,0,.817-.817v-.926A6.813,6.813,0,0,0,48.695,355Z",
    transform: "translate(0 -335.672)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3396",
    "data-name": "Path 3396",
    d: "M97.633,168.267V165a1.633,1.633,0,0,0,0,3.267Z",
    transform: "translate(-61.461 -156.017)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3397",
    "data-name": "Path 3397",
    d: "M135.223,5.412a.817.817,0,0,1,1.088-.06l2.5,2h1.347V7.078a7.078,7.078,0,0,0-14.156,0V7.35h4.543a6.619,6.619,0,0,0,4.68-1.939Z",
    transform: "translate(-89.828)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3398",
    "data-name": "Path 3398",
    d: "M211,341.966v.437a2.45,2.45,0,1,0,4.9,0v-.437a7.08,7.08,0,0,1-4.9,0Z",
    transform: "translate(-170.2 -323.348)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3399",
    "data-name": "Path 3399",
    d: "M161.172,137.639a.817.817,0,0,1,.817-.817h4.447a5.425,5.425,0,0,0,.453-2.178v-2.765L164.2,129.73a8.191,8.191,0,0,1-5.293,1.92H156v2.994a5.444,5.444,0,0,0,9.332,3.811h-3.343A.817.817,0,0,1,161.172,137.639Z",
    transform: "translate(-118.194 -122.667)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3400",
    "data-name": "Path 3400",
    d: "M330.6,168.267h.817v.544a1.363,1.363,0,0,1-1.361,1.361h-1.542a5.454,5.454,0,0,1-1.1,1.633h2.646a3,3,0,0,0,2.994-2.994v-2.178A1.633,1.633,0,0,0,331.412,165H330.6Z",
    transform: "translate(-280.267 -156.017)",
    fill: "#fafafa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCenterHelpDesk);
export default __webpack_public_path__ + "static/media/contact-center-help-desk.6ee5a490ce1958ae51e6e63906ee240a.svg";
export { ForwardRef as ReactComponent };